import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

// Page components
import { LandingPage } from './pages/LandingPage';
import { Dashboard } from './pages/Dashboard';
import { LeadDetail } from './pages/LeadDetail';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';

/**
 * Protected route wrapper for user authentication.
 * Checks localStorage for 'rewagent_user' session.
 * Redirects to / if not authenticated.
 */
function ProtectedRoute({ children }: { children: ReactNode }) {
  const stored = localStorage.getItem('rewagent_user');

  if (!stored) {
    return <Navigate to="/" replace />;
  }

  // Validate that the stored value is valid JSON
  try {
    JSON.parse(stored);
    return <>{children}</>;
  } catch {
    localStorage.removeItem('rewagent_user');
    return <Navigate to="/" replace />;
  }
}

/**
 * Protected route wrapper for admin authentication.
 * Checks localStorage for 'rewagent_admin' session.
 * Redirects to /admin if not authenticated.
 */
function AdminProtectedRoute({ children }: { children: ReactNode }) {
  const stored = localStorage.getItem('rewagent_admin');

  if (!stored) {
    return <Navigate to="/admin" replace />;
  }

  // Validate that the stored value is valid JSON
  try {
    JSON.parse(stored);
    return <>{children}</>;
  } catch {
    localStorage.removeItem('rewagent_admin');
    return <Navigate to="/admin" replace />;
  }
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Protected user routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lead/:id"
          element={
            <ProtectedRoute>
              <LeadDetail />
            </ProtectedRoute>
          }
        />
        
        {/* Admin routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />
        
        {/* Catch-all redirect to landing page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
